module.exports = __webpack_public_path__ + "img/btn_menu-open.5787fe30.png";